import { useEffect, useState } from "react";

export default function ClearwaterFinalCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );
    const el = document.getElementById("clearwater-final-cta");
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="clearwater-final-cta"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clearwater+Beach+Florida+at+golden+hour+sunset%2C+Pier+60+silhouette+against+orange+and+pink+sky%2C+calm+turquoise+Gulf+waters+reflecting+sunset+colors%2C+white+sand+shoreline+with+distant+resort+lights%2C+peaceful+tropical+evening+atmosphere%2C+professional+landscape+photography%2C+no+text+no+logos"
          alt="Clearwater Beach sunset at Pier 60 with golden sky and calm turquoise Gulf waters"
          className="w-full h-full object-cover object-center"
          width={1600}
          height={700}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div
          className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
        >
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Your Next Adventure Starts with a Valid Passport
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto">
            Whether you are catching a Phillies spring training flight to Toronto, boarding a Caribbean
            cruise from Tampa, or walking the beaches of Europe, do not let an expired or damaged
            passport stop you. Clearwater's expedited passport experts are ready.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Application <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-6 py-4 rounded-md transition-all backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
            </a>
          </div>

          <p className="text-white/50 text-xs mt-8">
            Registered courier service. A+ BBB accredited. Serving Clearwater, Pinellas County,
            Dunedin, Palm Harbor, Safety Harbor, and all Tampa Bay beach communities.
          </p>
        </div>
      </div>
    </section>
  );
}